module.exports = require('./_hide');


//////////////////
// WEBPACK FOOTER
// ./~/@deskproapps/dpat/~/core-js/library/modules/_redefine.js
// module id = 2C9O
// module chunks = 0